module.exports = __webpack_public_path__ + "img/logo-sandia-nat-lab-bw.90427ad2.png";